import {
  SYNC_USERS
} from '../actions/types';

export default function(state = [], action){
  switch(action.type){
    case SYNC_USERS:
      return action.payload;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js